/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="102.84"
        height="95.65"
        viewBox="0 0 102.84 95.65"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M53.24 32.25a1.26 1.26 0 0 1 1.71-.48 1.18 1.18 0 0 1 .4.37l.07.11 34.21 61.48a1.251 1.251 0 0 1-2.12 1.33l-.07-.12-33.11-59.53-24.61 44.31a1.26 1.26 0 0 1-1.58.55l-.12-.06a1.26 1.26 0 0 1-.55-1.58l.06-.12Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M26.37 46.5a1.26 1.26 0 0 1 1.72-.48 1.16 1.16 0 0 1 .4.36l.07.12 9.46 17a1.25 1.25 0 0 1-2.11 1.33l-.07-.11-8.37-15L2.34 94.94a1.25 1.25 0 0 1-1.57.55l-.14-.08a1.26 1.26 0 0 1-.54-1.58l.06-.12ZM80.87 58.41a1.26 1.26 0 0 1 1.7-.49 1.13 1.13 0 0 1 .41.37l.07.12 19.64 35.35a1.25 1.25 0 0 1-2.11 1.33l-.07-.12L82 61.59l-5.47 9.82a1.23 1.23 0 0 1-1.57.55l-.13-.06a1.26 1.26 0 0 1-.54-1.58l.06-.12Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M40.53 55.22a1.27 1.27 0 0 1 1.67-.09l.1.09 6.19 6.19 5-5a1.24 1.24 0 0 1 1.66-.09l.11.09 5 5 6.19-6.19a1.26 1.26 0 0 1 1.55-.09l.1.09a1.25 1.25 0 0 1 .09 1.67l-.09.1-7.08 7.08a1.25 1.25 0 0 1-1.66.09l-.11-.09-5-5-5 5a1.28 1.28 0 0 1-1.67.09l-.1-.09-7.08-7.08a1.28 1.28 0 0 1 .13-1.77Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M74.12 2.95v17.63H54.33v-2.5h17.3V5.41h-17.3v-2.5Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M72 6.49h20.06l-8.43 8.81 8.45 8.81H66.84v-4.78h2.5v2.28H86.2l-6.06-6.31 6.06-6.31H72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M54.33 0a1.26 1.26 0 0 1 1.25 1.12v31.74a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09V1.25A1.25 1.25 0 0 1 54.33 0Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'MountaintopWithFlagIcon';

export default Icon;
